import type { PageRouteDefinition, QueryParamValues, QueryParamValuesSetter, UnknownQueryParam } from "@octopusdeploy/portal-routes";
import type { ReactElement } from "react";
import type { PermissionCheckProps } from "~/components/PermissionCheck/PermissionCheck";
import type { Loader } from "~/routing/pageRegistrations/Loader";
import type { LoadingContentRender, PageRegistration } from "~/routing/pageRegistrations/PageRegistration";
import type { StandardLoaderContext } from "~/routing/pageRegistrations/StandardLoaderContext";
import type { StandardPageContext } from "~/routing/pageRegistrations/StandardPageContext";
import { pageAreas } from "../PageAreaContext";
import type { PageOwner } from "./pageOwner";
export function createConfigurationPageRegistration<RouteParams, QueryParams extends UnknownQueryParam[], LoaderData>(route: PageRouteDefinition<RouteParams, QueryParams>, config: {
    render: (parameters: {
        context: StandardPageContext;
        loaderData: LoaderData;
        routeParams: RouteParams;
        queryParams: QueryParamValues<QueryParams>;
        setQueryParams: QueryParamValuesSetter<QueryParamValues<QueryParams>>;
    }) => ReactElement;
    pageId: string;
    owner: PageOwner;
    loader?: Loader<LoaderData, StandardLoaderContext, RouteParams, QueryParams>;
    loadingTitle?: string;
    loadingContent?: LoadingContentRender;
    helpContent?: () => ReactElement;
    helpTopics?: () => ReactElement;
    requiredPermission?: PermissionCheckProps;
}): PageRegistration<RouteParams, QueryParams, LoaderData, StandardLoaderContext, StandardPageContext> {
    return {
        route,
        render: config.render,
        pageId: config.pageId,
        owner: config.owner,
        pageArea: pageAreas.configuration,
        searchKeywords: [],
        loader: config.loader,
        loadingTitle: config.loadingTitle,
        loadingContent: config.loadingContent,
        helpContent: config.helpContent,
        helpTopics: config.helpTopics,
        level: 2,
        isFullWidth: false,
        requiredPermission: config.requiredPermission,
    };
}
